/**
 * Yeni sürüm sonrası bayat sekme kurtarma.
 *
 * Deploy sonrası açık kalan sekme eski index'i taşır; rota chunk'ının eski hash'li
 * adı (ör. TeklifDetailPage-<eski>.js) artık sunucuda yoktur → 404 →
 * "Failed to fetch dynamically imported module". Vite her dinamik import hatasında
 * `vite:preloadError` olayı yayar; burada sayfayı BİR KEZ yeniden yükleriz, yeni
 * index.html yeni chunk adlarını getirir.
 *
 * Döngü koruması: son yenileme zamanı sessionStorage'da tutulur; KORUMA_MS içinde
 * ikinci hata gelirse yenilenmez, hata normal akışla error boundary'ye düşer.
 * sessionStorage erişilemezse (gizli mod kısıtı vb.) yenileme yapılmaz.
 */
const ANAHTAR = 'zoprey:yeni-surum-yenileme';
const KORUMA_MS = 60_000;

let yenileniyor = false;

/** Yenileme başlatıldıysa true — error boundary bu arada hata ekranı göstermesin. */
export function yenilemeSuruyor(): boolean {
  return yenileniyor;
}

/** Korumaya takılmıyorsa yenilemeyi başlatır; başlattıysa (ya da zaten sürüyorsa) true döner. */
export function yeniSurumIcinYenile(yenile: () => void = () => window.location.reload()): boolean {
  if (yenileniyor) return true;
  try {
    const son = Number(sessionStorage.getItem(ANAHTAR) ?? 0);
    if (Date.now() - son < KORUMA_MS) return false;
    sessionStorage.setItem(ANAHTAR, String(Date.now()));
  } catch {
    return false;
  }
  yenileniyor = true;
  yenile();
  return true;
}

/** `vite:preloadError` dinleyicisini kurar; main.tsx'te dinamik importlardan önce çağrılır. Kaldırma fonksiyonu döner. */
export function yeniSurumYenilemesiniKur(yenile?: () => void): () => void {
  const dinleyici = () => {
    yeniSurumIcinYenile(yenile);
  };
  window.addEventListener('vite:preloadError', dinleyici);
  return () => window.removeEventListener('vite:preloadError', dinleyici);
}

/** Yalnız testler için: modül durumunu sıfırlar. */
export function _sifirla(): void {
  yenileniyor = false;
}
